<div oui-dialog-title>
  Historique du fichier
  <oui-button type="icon" oui-dialog-close>
    <oui-icon>close</oui-icon>
  </oui-button>
</div>
<oui-dialog-content [scroll]="true">
  @if (isloading) {
    <div class="loading-container">
      <oui-loading size="small"></oui-loading>
    </div>
  }

  @if (historyDisplayedEntries) {
    <lib-history
      [records]="historyDisplayedEntries"
    (documentOpen)="documentOpen.emit($event)"></lib-history>
  }
</oui-dialog-content>
